import { jsx } from '@emotion/react';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { SkeletonBlock } from '../SkeletonBlock/SkeletonBlock.es.js';

const Styles = labelStyles("SkeletonText", {
  root: (textAlign) => [
    {
      display: "grid",
      gridTemplateColumns: "100%",
      gap: 5
    },
    withModifier(textAlign, {
      justifyItems: {
        left: "start",
        right: "end",
        center: "center",
        justify: "left"
      }[textAlign]
    })
  ]
});
const getLineHeight = (size) => ({
  heading: "var(--zds-line-height-medium, 30px)",
  body: "var(--zds-line-height-small, 15px)"
})[size];
const getLineWidth = (props, idx) => {
  if (idx === 0 && props.lines === 1) {
    return "100%";
  }
  if (idx === props.lines - 1) {
    return "70%";
  }
  if (props.textAlign === "justify") {
    return "100%";
  }
  return idx % 2 ? "100%" : "93%";
};
const SkeletonText = ({ lines, size = "body", textAlign = "left", width = "100%", color = "neutral200" }) => {
  const blocks = Array.from({ length: lines }).map((_, idx) => {
    return jsx(SkeletonBlock, { height: getLineHeight(size), key: idx, width: getLineWidth({ lines, textAlign }, idx), color });
  });
  const style = {
    width
  };
  return jsx("div", { css: Styles.root(textAlign), "data-testid": "SkeletonText", "data-zds": true, style }, blocks);
};

export { SkeletonText };
//# sourceMappingURL=SkeletonText.es.js.map
